<template>
  <div>
    <!-- 内容区 -->
    <div class="content">
      <div class="w">
        <div class="form">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" size="medium">
            <el-form-item label="车辆名称" prop="vehicleName">
              <el-col :span="10">
                <el-input v-model="ruleForm.vehicleName" style="width: 100%;"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="车架号" prop="shelfCode">
              <el-col :span="10">
                <el-input v-model="ruleForm.shelfCode" style="width: 100%;"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="车牌号" prop="licenseCode">
              <el-col :span="10">
                <el-input v-model="ruleForm.licenseCode" style="width: 100%;"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="车辆图片" prop="pics">
              <el-upload
                action
                :http-request="uploadImg"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :on-exceed="handleExceed"
                :on-success="uploadSuccess"
                :file-list="ruleForm.pics"
                :before-upload="beforeAvatarUpload"
                list-type="picture"
                :on-change="imgChange"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">请上传jpg/png文件，且不超过2MB</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="车辆描述" prop="condDesc">
              <el-input type="textarea" v-model="ruleForm.condDesc"></el-input>
            </el-form-item>
            <el-form-item label="车主姓名" prop="username">
              <el-col :span="10">
                <el-input v-model="ruleForm.username" style="width: 100%;"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="车主手机号" prop="usertel">
              <el-col :span="10">
                <el-input v-model="ruleForm.usertel" style="width: 100%;"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">立即发布</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ossClient from '@/utils/alioss'
import menus from '../utils/menu'
export default {
  data() {
    return {
      ruleForm: {
        vehicleName: '',
        shelfCode: '',
        licenseCode: '',
        condDesc: '',
        username: '',
        usertel: '',
        coverUrl: '',
        pics: []
      },
      rules: {
        condDesc: [{ required: true, message: '请填写车辆描述', trigger: 'blur' }],
        username: [{ required: true, message: '请填写车主姓名', trigger: 'blur' }],
        usertel: [{ required: true, message: '请填写车主手机号', trigger: 'blur' }],
        licenseCode: [{ required: true, message: '请填写车牌号', trigger: 'blur' }],
        shelfCode: [{ required: true, message: '请填写车架号', trigger: 'blur' }],
        vehicleName: [{ required: true, message: '请填写车辆名称', trigger: 'blur' }],
        pics: [{ required: true, message: '请上传车辆图片', trigger: 'change' }]
      },
      uploadConf: {
        accessKeyId: 'LTAI4Ft3sQrSb3EGtJswDPTX',
        accessKeySecret: 'qNIm3LWCQISpYFlnSfMzq4TAYpwGtG',
        bucket: 'new-store',
        region: 'oss-cn-beijing'
      } // 配置对象
    }
  },
  created() {
    var menuActive = this.$route.name
    if (menuActive == this.$store.state.menuActive) {
    } else {
      var keys = Object.keys(menus)
      if (keys.findIndex(item => item == menuActive) != -1) {
        this.$store.commit('setMenuActive', menuActive)
      }
    }

    if (this.$route.query.usertel) {
      this.ruleForm.usertel = this.$route.query.usertel
    }
  },
  computed: {},
  methods: {
    // 图片删除后
    handleRemove(file, pics) {
      var index = this.ruleForm.pics.findIndex(item => item.name == file.name)
      this.ruleForm.pics.splice(index, 1)
    },
    // 点击
    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, pics) {
      this.$message.warning(`本次选择了 ${files.length} 个文件，共选择了 ${files.length + pics.length} 个文件`)
    },
    // 删除前
    beforeRemove(file, pics) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 上传前大小验证
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      // if (!isJPG) {
      //   this.$message.error('上传车辆图片只能是 JPG或者PNG 格式!')
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传车辆图片大小不能超过 2MB!')
      // } else {
      // }
      // return isJPG && isLt2M
      return isLt2M
    },
    uploadImg({ file }) {
      var that = this
      console.log(file)
      // const { imgName } = 'ALIOSS_IMG_'
      // const fileName = `${imgName}/${Date.parse(new Date())}` // 定义唯一的文件名
      var suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      var randName = 'pic_' + new Date().getTime() + Math.floor(Math.random() * 10000)
      var fileName = randName + '.' + suffix
      ossClient(this.uploadConf)
        .put(fileName, file, {
          ContentType: 'image/jpeg'
        })
        .then(({ res, url, username }) => {
          if (res && res.status == 200) {
            console.log('阿里云OSS上传图片成功回调', res, url, username)
            that.ruleForm.pics.push({
              name: file.name,
              url: url
            })
          }
        })
        .catch(err => {
          console.log('阿里云OSS上传图片失败回调', err)
        })
    },
    // 上传成功
    uploadSuccess(response, file, pics) {
      console.log(pics)
      console.log(response)
      console.log(file)
    },
    // 添加图片消除验证
    imgChange() {
      this.$refs.ruleForm.clearValidate('pics')
    },
    async submitForm(formName) {
      // this.ruleForm.pics.forEach(element => {})
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.ruleForm.coverUrl = this.ruleForm.pics[0].url
          const { data } = await this.$http.post(this.$store.state.web4open_api + '/web/vehicleSale/doVehicleSaleAdd', JSON.parse(JSON.stringify(this.ruleForm)))
          if (data.success) {
            this.$message({
              message: '恭喜你，您已成功预约卖车，稍后会有您的专属汽车顾问联系您哦！',
              type: 'success'
            })
          } else {
            this.$message.error(data.message)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.content {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #f2f2f2;
  .w {
    background-color: #fff;
  }
}
.form {
  width: 60%;
  padding: 20px 0;
  margin: 0 auto;
}
</style>
